export const ADD_GG_CONTACT_MODAL_NAME = 'ADD_GG_CONTACT_MODAL_NAME';
